import React from 'react';
import InfiniteProgressBar from '../infinite-progress-bar/infinite-progress-bar';
import Icon from '../icon';

const Loading = ({ spinner, fill, ...rest }) => {
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    return spinner ? <Icon type="spinner" pulse {...rest} /> : <InfiniteProgressBar fill={fill} {...rest} />;
};

export default Loading;
